import { render, staticRenderFns } from "./PredictionPieChart.vue?vue&type=template&id=5ef708c4&scoped=true"
import script from "./PredictionPieChart.vue?vue&type=script&lang=js"
export * from "./PredictionPieChart.vue?vue&type=script&lang=js"
import style0 from "./PredictionPieChart.vue?vue&type=style&index=0&id=5ef708c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef708c4",
  null
  
)

export default component.exports